import axios, { AxiosInstance, AxiosRequestConfig } from "axios";

const headers: any = {};
if (process.env.NODE_ENV === "development") {
  headers["organization"] = "test";
  headers["apiKey"] = "test";
  headers["language"] = "uz";
}
const config: AxiosRequestConfig = {
  baseURL: process.env.REACT_APP_BASE_URL,
  timeout: 15000,
  headers: headers,
};

axios.interceptors.request.use(
  (config) => {
    return {
      ...config,
      baseURL: process.env.REACT_APP_BASE_URL,
      timeout: 31000,
      headers: headers,
    };
  },
  (error) => {
    return Promise.reject(error);
  }
);

export const axiosInstance: AxiosInstance = axios.create(config);

export default axios;
